import { API_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
})

/**
 * Clase para ver el todo lo relacionado con pedidos auxiliares
 */
export default class PedidosAuxiliaresRequest {
    /**
     * Método para obtener los artículos para generar pedido auxiliar
     * @param {String} filtro : string que representa el número de pedido del cual obtener la información.
     * @return {} :
     */
     static ListarArticulosGenerar(data) {
        return middleware.hasAuth(() => request.get(`api/generar-pedido-auxiliares/`, {
            params: {
                categoria: 27,
                drive_id: data?.drive_id
            }
        }))
    }

    /**
     * Llamada el endpoint de django para categorizar un artículo y guardar su
     * configuración en la BD
     * @param: value. id de categoría
     * @param: data. una lista de objetos que contiene los artículos
     * @return: Mensaje de éxito o error.
     */
     static GenerarPedido(value, data) {
        return middleware.hasAuth(() => request.post(`api/generar-pedido-auxiliares/?categoria=${value}`, data))
    }


    /**
     * Método para obtener los artículos para generar el pedido auxiliar
     */
    static CargarArticulos(data) {
        return middleware.hasAuth(() => request.get(`api/articulos/auxiliares`))
    }

    /**
     * Llamada el endpoint de django para categorizar un artículo y guardar su
     * configuración en la BD
     * @param: value. id de categoría
     * @param: data. una lista de objetos que contiene los artículos
     * @return: Mensaje de éxito o error.
     */
    static GenerarPedidoAux(value, data) {
        return middleware.hasAuth(() => request.post(`api/generar-pedido/auxiliares?categoria=${value}`, data))
    }

    /**
     * Llamada al endpoint para traer los consolidados que existen dentro de la 
     * BD.
     * @param {Object} obj : objeto que contiene los filtros para los consolidados
     * @return {} :
     */
    static CargarPedidosAuxiliares(value, obj = undefined, categoria) {
        return middleware.hasAuth(() => request.get(`/api/lista-pedidos/auxiliares/`,
            {
                params: {
                    'busqueda': obj ? obj.busqueda : undefined,
                    'estatus_filtrado': obj ? obj.estatus : undefined,
                    'fecha_inferior_realizado': obj ? obj.dateInicioPedido : undefined,
                    'fecha_superior_realizado': obj ? obj.dateFinPedido : undefined,
                    'fecha_inferior_vencimiento': obj ? obj.dateInicioVencimiento : undefined,
                    'fecha_superior_vencimiento': obj ? obj.dateFinVencimiento : undefined,
                    'page': obj ? obj.page : undefined,
                    'categoria': categoria,
                    'id_sitio': value
                }
            }
        ));
    }

    static CargarArticulosPedidoAuxPag(Id, page = undefined){
        return middleware.hasAuth(() => request.get(`api/pedidoaux-detalle`, {
            params: {
                'page': page ? page : undefined,
                'id_pedido': Id
            }
        }));
    }
}